var equalizeHeadingHeights = {
    'init': function (selector) {
        var elements = jQuery(selector).closest('.row').find('h2');
        var defaultMargin = parseInt(elements.css('margin-bottom'));

        equalizeHeadingHeights.equalize(elements);

        jQuery(window).resize(function () {
            if (jQuery(window).width() >= 768) {
                equalizeHeadingHeights.equalize(elements);
            } else {
                elements.css({"margin-bottom": defaultMargin + "px"});
            }
        });
    },
    'equalize': function (elements) {
        var maxHeight = 0;
        var minMarginBottom = 1000;
        
        elements.each(function () {
            if (jQuery(this).height() > maxHeight) {
                maxHeight = jQuery(this).height();
            }
            var padding = parseInt(jQuery(this).css('margin-bottom'));
            if (padding < minMarginBottom) {
                minMarginBottom = padding;
            }
        });
        elements.each(function () {
            if (jQuery(this).height() < maxHeight) {
                var ownHeight = jQuery(this).height();
                var marginBottom = minMarginBottom + (maxHeight - ownHeight);
                jQuery(this).css({"margin-bottom": marginBottom + "px"});
            } else {
                jQuery(this).css({"margin-bottom": minMarginBottom + "px"});
            }
        });
    }
};


